import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'

// local imports
import { IOnCampusHealthServiceFirmStatistics } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function LactationServiceDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [[t('most-used-words.firm'), t('lactation-res-modal.lactation-reservation')]]

      const arr = excelData?.map((res: any) => {
        const { FirmName, CameCount } = res
        return { FirmName, CameCount }
      })

      const totalRow = arr.reduce(
        (acc: IOnCampusHealthServiceFirmStatistics, curr: IOnCampusHealthServiceFirmStatistics) => {
          acc.cameCount += curr.cameCount || 0
          return acc
        },
        {
          FirmName: '',
          CameCount: 0,
        }
      )

      let heading2 = {
        FirmName: '',
        CameCount: t('dashboard.on-campus-tabs.lactation-detail-msg'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.on-campus-tabs.lactation-res'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
